import { combineReducers } from "redux";
import authReducer from "./auth/reducer";

export const globalReducers = combineReducers({
    auth: authReducer,
});

export type RootState = ReturnType<typeof globalReducers>;
